import { useApi } from '@/api';
import { KpiSkeleton, KpiCard } from '@blockanalitica/ui';

type Market = {
  underlying_symbol: string;
  underlying_address: string;
  underlying_name: string;
  total_supply: string;
  total_supply_usd: string;
  total_supply_change: string | null;
  total_supply_change_percentage: string | null;
  total_borrow: string;
  total_borrow_usd: string;
  total_borrow_change: string | null;
  total_borrow_change_percentage: string | null;
  supply_apy: string;
  supply_apy_change: string | null;
  supply_apy_change_percentage: string | null;
  borrow_apy: string;
  borrow_apy_change: string | null;
  borrow_apy_change_percentage: string | null;
  utilization_rate: string;
  utilization_rate_change: string | null;
  utilization_rate_change_percentage: string | null;
  available_liquidity_change_percentage: string | null;
  underlying_price: string;
  underlying_price_change: string | null;
  underlying_price_change_percentage: string | null;
  num_of_borrowers: string;
  num_of_borrowers_change: string | null;
  num_of_borrowers_change_percentage: string | null;
  num_of_suppliers: string;
  num_of_suppliers_change: string | null;
  num_of_suppliers_change_percentage: string | null;
};

export default function AtRiskKpis({
  marketAddress
}: {
  marketAddress: string;
}) {
  const [data, error] = useApi<Market>({
    url: `/markets/${marketAddress}/at-risk-stats/`
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <KpiSkeleton />;
  }

  const statsData =
    Object.keys(data).length === 0
      ? { liquidated: '0', liquidations_count: '0' }
      : data;

  return (
    <KpiCard
      title="Liquidated at 10% drop"
      data={statsData}
      field="liquidated"
      options={{
        valueOptions: {
          currencyValueOptions: {
            currency: 'USD',
            notation: 'compact'
          }
        }
      }}
    />
  );
}
